// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-queryStudents-tyQueryStudents-index-main_right_content-2Q5de","table":"components-tjcx-queryStudents-tyQueryStudents-index-table-2l3kw"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/queryStudents/tyQueryStudents/index.css
// module id = 2311
// module chunks = 0